import {
  createContext,
  useContext,
  useState,
  useEffect,
  type ReactNode,
} from "react";

type SideMenuContextType = {
  isSideMenuOpen: boolean;
  setIsSideMenuOpen: (open: boolean) => void;
};

const SideMenuContext = createContext<SideMenuContextType | undefined>(
  undefined
);

const STORAGE_KEY = "sidemenu-open";

export const SideMenuProvider = ({ children }: { children: ReactNode }) => {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? stored === "true" : true;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(isSideMenuOpen));
  }, [isSideMenuOpen]);

  return (
    <SideMenuContext.Provider value={{ isSideMenuOpen, setIsSideMenuOpen }}>
      {children}
    </SideMenuContext.Provider>
  );
};

export const useSideMenu = (): SideMenuContextType => {
  const context = useContext(SideMenuContext);
  if (!context) {
    throw new Error("useSideMenu must be used within a SideMenuProvider");
  }
  return context;
};
